module.exports = __webpack_public_path__ + "static/media/66860005-jKU0wSgs.25960c8f.JPG";